import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';

import './index.css';

const parserOptions = {
};

const HtmlParser = ({ htmlString }) => (
  <div>
    { Parser(htmlString || '', parserOptions) }
  </div>
);

HtmlParser.propTypes = {
  htmlString: PropTypes.string,
};
HtmlParser.defaultProps = {
  htmlString: '',
};

export default HtmlParser;



// WEBPACK FOOTER //
// ./src/components/Offering/HtmlParser.js